import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import {
  BackgroundContainer,
  AbsolutePositioned
} from '../../../components/Layout/AbsolutePositioned';
import { ContentContainer } from '../../../components/Layout/ContentContainer';
import { DiagonalLine, VerticalLine, HorizontalLine } from '../../../components/Layout/Line';
import { Screen, SplitScreen, SplitScreenContentHolder } from '../../../components/Layout/Screen';
import Logo from '../../../components/Logo';
import Title, { Highlight, Subtext } from '../../../components/Title';

// Assets
import { brandColors, device } from '../../../styles/variables';
import blueLogo from '../../../assets/images/logos/rd-logo-dark.png';
import background from '../../../assets/images/brand_botanical.png';

const OverlayBackground = AbsolutePositioned.extend`
  width: 100%;
  height: 100%;
  background: url(${background}) center no-repeat;
  background-size: 120%;
  opacity: 0.9;
`;

const StyledSplitScreen = SplitScreen.extend`
  position: relative;
  height: 100%;
  ${({ backgroundColor = 'none' }) => `
    background: ${backgroundColor};
  `};
  pointer-events: all;
`;

const TitlePosition = styled.div`
  width: 100%;
  max-width: 1169px;
  padding: 154px 0 0;
  @media ${device.tablet} {
    padding: 121px 0 0 0;
  }
  @media ${device.laptop} {
    padding: 57px 0 0 0;
  }
  @media ${device.laptopL} {
    padding: 106px 0 0 0;
  }
`;

const ContentHolder = styled.div`
  position: relative;
  pointer-events: none;
  padding: 0;
  height: 100%;
  width: 100%;
  z-index: 2;
`;

const FeatureScreen = () => (
  <Screen background={brandColors.yellow}>
    <OverlayBackground />
    <BackgroundContainer>
      <HorizontalLine />
      <VerticalLine />
      <StyledSplitScreen>
        <SplitScreenContentHolder direction="right">
          <DiagonalLine />
          <VerticalLine />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
      <StyledSplitScreen>
        <SplitScreenContentHolder>
          <DiagonalLine />
          <VerticalLine />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
    </BackgroundContainer>
    <ContentHolder>
      <Logo logo={blueLogo} />
      <ContentContainer>
        <TitlePosition>
          <Title subtitle="our services" color={brandColors.blue}>
            Introducing science, <Highlight>through</Highlight> creativity
            <Subtext>
              Our unique expertise across science, technology and creative arts delivers solutions
              for all your business goals.
            </Subtext>
          </Title>
        </TitlePosition>
      </ContentContainer>
    </ContentHolder>
  </Screen>
);

export default connect()(FeatureScreen);



// WEBPACK FOOTER //
// ./src/pages/Services/screens/Feature.jsx